import React, { useCallback, useRef } from 'react'
import { Form } from 'antd'
import BaseModalForm from 'components/BaseModalForm';
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import { MODAL_SIZE_MEDIUM } from 'constants/Layout';
import message from 'components/CustomMessage';
import { noLocalhostValidator } from 'utils/validatorUtil';

const ArmorCodeAgentMappingForm = ({ onFinish }) => {
    const [form] = Form.useForm();
    const thisRef = useRef();


    const onSave = useCallback((values) => {
        const { serviceName, serviceUrl, environment } = values;
        try {
        
            const url = new URL(serviceUrl);
            const data = {
                name: serviceName,
                domain: url.hostname,
                connectUrl: serviceUrl,
                envName: environment
            };
            onFinish(data);
        } catch (error) {
            console.error(error);
            message.error('Invalid data provided. Please check and try again.');
        }
    }, [onFinish]);


    const modalProps = {
        width: MODAL_SIZE_MEDIUM
    }

    return (
        <BaseModalForm
            ref={thisRef}
            form={form}
            title={"Please add domain configuration to proxy via Web Agent"}
            modalProps={modalProps}
            onOk={onSave}
            fields={[
                {
                    name: 'serviceName',
                    label: 'Service Name',
                    rules: [{ required: true, message: 'Please enter service name' }],
                    type: FieldTypes.INPUT,
                },
                {
                    name: 'serviceUrl',
                    label: 'Service Url',
                    rules: [
                        { required: true, message: 'Please enter service Url' },
                        noLocalhostValidator,
                        urlRegexValidator,
                    ],
                    type: FieldTypes.INPUT,
                    placeholder: 'http(s)://host:port/path?query#fragment',
                },
                {
                    name: 'environment',
                    type: FieldTypes.INPUT,
                    colSpan: 12,
                    placeholder: 'Environment',
                    label: 'Environment',
                    help: 'Fill the environment name used to start the web-agent. Leave blank if not specified in the web-agent',
                },
            ]}
        />
    )
}

export default ArmorCodeAgentMappingForm;

